/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { A as ActionGroup, d as defineCustomElement$1 } from './action-group.js';

const CalciteActionGroup = ActionGroup;
const defineCustomElement = defineCustomElement$1;

export { CalciteActionGroup, defineCustomElement };

//# sourceMappingURL=calcite-action-group.js.map